import { Divider } from '@chakra-ui/react';
export const CUIDivider = Divider;